import type { PlayerCardData } from '../types'
import { weightLb } from '../format'

// Bio is pure flavor — and on the Summary cheat-sheet it earns exactly one
// muted line at the bottom, zero section chrome. Physical + acquired on the
// left; the league gets a nameplate-style stamp in the bottom-right corner
// (echoes the header's team nameplate: uppercase, letter-spaced). Experience
// and the drafted detail live on the History tab.
export function BioFooter({ player }: { player: PlayerCardData }) {
  const b = player.bio
  const a = player.acquisition
  return (
    <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 pt-3 pb-1">
      <p className="text-[13px] text-slate-500 tabular-nums">
        {b.height} / {b.weight != null ? weightLb(b.weight) : '—'}
        <span className="mx-1.5 text-slate-300">·</span>
        <span className="text-slate-400">Acquired:</span> {a.acquiredBy}
        {a.acquiredBySeason ? `, ${a.acquiredBySeason}` : ''}
      </p>
      {player.league && (
        <p className="ml-auto text-[11px] font-bold uppercase tracking-[0.18em] text-navy">
          {player.league.name}
        </p>
      )}
    </div>
  )
}
